<template>
  <div :class="bemBlock">
    <button
      :class="[
        bemElement('btn-close'),
        'btn-close',
        'u-btn-clean',
        'u-btn-clean--transparent',
      ]"
      @click="$emit('close-click')"
    >
      <span class="visually-hidden">reset</span>
    </button>
    <BaseImage
      v-for="(imageSet, index) in images"
      :key="`pdp-zoom-img-${index}`"
      :class="bemElement('pic')"
      :src="getDefaultImageUrlFromProductImageSet(imageSet)"
      :alt="getDefaultImageAltFromProductImageSet(imageSet)"
      :loading="loading"
      :placeholder="getPlaceholderImageUrlFromProductImageSet(imageSet)"
      sizes="100vw"
      :srcset="getSrcsetFromProductImageSet(imageSet)"
    />
  </div>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import { productImageSetMixin } from '../mixins/productImageSetMixin';
import BaseImage from './BaseImage.vue';

export default {
  name: 'TheProductDetailsZoom',

  components: {
    BaseImage,
  },

  mixins: [bemClassesMixin, productImageSetMixin],

  props: {
    images: {
      type: Array,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    /**
     * Same spec as HTML specification:
     * https://html.spec.whatwg.org/multipage/urls-and-fetching.html#lazy-loading-attributes
     *
     * However, default value will be 'lazy'
     */
    loading: {
      type: String,
      required: false,
      default: 'lazy',
      validator: (prop) => ['eager', 'lazy'].includes(prop),
    },
    /**
     * @type {object} required data for positioning in the zoom image
     * @property {number} ordinal - Which image should be targeted
     * @property {number} percentileY - Relative-to-height position (y) to center
     * the zoom inside the image. Ex: 0.25
     */
    zoomRequirements: {
      type: Object,
      required: true,
      default: () => ({
        ordinal: null,
        percentileY: null,
      }),
    },
  },

  computed: {
    zoomIsVisible() {
      return this.isVisible;
    },
  },

  mounted() {
    this.handleListeners();
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },

  methods: {
    handleListeners() {
      document.addEventListener('keydown', this.handleKeydown);
    },
    handleKeydown(e) {
      if (e.which === 27) {
        // ESC
        this.$emit('close-click');
      }
    },
  },
};
</script>
